// extracted by mini-css-extract-plugin
export default {"modal":"UserInstructionsModal_modal__RHZMl","termsContent":"UserInstructionsModal_termsContent__ZNDNy","markdown":"UserInstructionsModal_markdown__N63fp"};